import { render } from "./BookingsReportList.vue?vue&type=template&id=7f7d4cd0"
import script from "./BookingsReportList.vue?vue&type=script&lang=js"
export * from "./BookingsReportList.vue?vue&type=script&lang=js"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__